import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import ContractRateService from "../../../../services/rates/ContractRateService";

export const REQUEST_DELETE_CONTRACT_RATE = "REQUEST_DELETE_CONTRACT_RATE";
export const DELETE_CONTRACT_RATE_SUCCESS = "DELETE_CONTRACT_RATE_SUCCESS";
export const DELETE_CONTRACT_RATE_ERROR = "DELETE_CONTRACT_RATE_ERROR";

function requestDeleteContractRate() {
  return {
    type: REQUEST_DELETE_CONTRACT_RATE,
  };
}

function deleteContractRateSuccess(json) {
  return {
    type: DELETE_CONTRACT_RATE_SUCCESS,
    message: json.data,
  };
}

function deleteContractRateError(json) {
  return {
    type: DELETE_CONTRACT_RATE_ERROR,
    error: json.data,
  };
}

export function deleteContractRate(contract_id) {
  return (dispatch) => {
    dispatch(requestDeleteContractRate());
    return ContractRateService.deleteContract(contract_id).then((json) => {
      if (json.data.code === 200) {
        dispatch(deleteContractRateSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(deleteContractRate(contract_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(deleteContractRateError(json.data));
      }
    });
  };
}
